import { GERMANY_CONTRACT_ADDENDUM_TYPES } from '../../../../../../shared/constants'

const moment = require('moment')

export const germanHolidays = []

export const calculateDiffInBusinessDaysFromToday = endDate => {
  let start = moment()
  let end = moment(endDate).endOf('day')

  const holidaySet = new Set(
    germanHolidays.map(holiday =>
      moment(holiday)
        .startOf('day')
        .format('YYYY-MM-DD'),
    ),
  )
  let businessDays = 0
  while (end.diff(start, 'days') > 0) {
    const isWeekend = start.day() === 0

    const isHoliday = holidaySet.has(start.format('YYYY-MM-DD'))

    if (!isWeekend && !isHoliday) {
      businessDays++
    }

    start.add(1, 'days')
  }

  return businessDays
}
export const addNumberOfWorkingDays = (date, workingDaysToAdd) => {
  const isWeekend = date => {
    const day = date.day()
    return day === 0
  }

  const isHoliday = date => {
    const formattedDate = date.format('YYYY-MM-DD')
    return germanHolidays.includes(formattedDate)
  }

  let newDate = moment(date)
  let workingDaysCount = 0

  while (workingDaysCount < workingDaysToAdd) {
    if (!isWeekend(newDate) && !isHoliday(newDate)) {
      workingDaysCount++
    }
    newDate = newDate.add(1, 'days')
  }
  return newDate
}

export const validateEndDate = ({
  endDate,
  contract,
  type,
  setErrors,
  isDatesInRangeContract,
}) => {
  setErrors(prev => ({
    ...prev,
    endDate: null,
  }))

  // Validation: Contract Extension
  if (type == GERMANY_CONTRACT_ADDENDUM_TYPES.CONTRACT_EXTENSION) {
    const contractEnd = endDate
    const targetDate = moment(contract.endAt).add(1, 'day')

    const isInvalid = contractEnd.isBefore(targetDate)
    if (isInvalid) {
      return setErrors(prev => ({
        ...prev,
        endDate: `Enter a valid date after general contract's end date`,
      }))
    }
  }

  // Validation: “Immediate Resignation“ and “Future resignation (future date)
  // Can’t be earlier than <today>;
  // Skipped if isDatesInRangeContract is true requirements here https://oppizi-ltd.atlassian.net/browse/PAD-21074
  if (
    [GERMANY_CONTRACT_ADDENDUM_TYPES.FUTURE_RESIGNATION].includes(type) &&
    !isDatesInRangeContract
  ) {
    const contractEnd = endDate
    const targetDate = moment(new Date()).subtract(1, 'day')

    const isBeforeNeededDate = contractEnd.isBefore(targetDate)

    if (isBeforeNeededDate) {
      return setErrors(prev => ({
        ...prev,
        endDate: `Enter a valid date within the validity range of the general contract`,
      }))
    }
  }
}

export const getDefaultEndDate = ({
  type,
  isDatesInRangeContract,
  contractEndAt,
}) => {
  if (
    [
      GERMANY_CONTRACT_ADDENDUM_TYPES.IMMEDIATE_RESIGNATION,
      GERMANY_CONTRACT_ADDENDUM_TYPES.FUTURE_RESIGNATION,
    ].includes(type)
  ) {
    if (isDatesInRangeContract) {
      return moment(new Date(contractEndAt))
    }
    return moment(new Date())
  }
  if (
    [
      GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SHOW_UP,
      GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SEND_LETTER,
    ].includes(type)
  ) {
    return getImmediateTerminationEndDate()
  }
  if (type == GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_LESS_THAN_6_MONTH) {
    return getTerminationEndDateBelow6month()
  }
  if (type == GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_MORE_THAN_6_MONTH) {
    return getTerminationEndDateAbove6month()
  }
}

export const getStartsOfCurrentAndNextMonth = (contract = {}) => {
  const currentDate = moment()
  let firstDayOfCurrentMonth = moment(currentDate)
    .startOf('month')
    .format('YYYY-MM-DD')

  if (moment(firstDayOfCurrentMonth).isBefore(contract.startAt)) {
    firstDayOfCurrentMonth = contract.startAt
  }

  const firstDayOfNextMonth = moment(currentDate)
    .add(1, 'months')
    .startOf('month')
    .format('YYYY-MM-DD')

  return { current: firstDayOfCurrentMonth, next: firstDayOfNextMonth }
}

export const getTerminationEndDateBelow6month = () => {
  const terminationPeriod = 16
  const currentMoment = moment()
  const currentHour = currentMoment.hours()
  const currentDay = currentMoment.day()
  let date
  if (currentDay <= 5 && currentHour < 13) {
    date = moment().add(terminationPeriod, 'days')
  }
  if (currentDay <= 4 && currentHour >= 13) {
    date = moment().add(terminationPeriod + 1, 'days')
  }
  if (currentDay == 5 && currentHour >= 13) {
    date = moment().add(terminationPeriod + 3, 'days')
  }
  return date
}

export const getTerminationEndDateAbove6month = () => {
  const terminationPeriod = 30

  const currentMoment = moment()
  const currentHour = currentMoment.hours()
  const currentDay = currentMoment.day()
  const currentMonth = currentMoment.month()

  const is31Flow = currentDay <= 5 && currentHour < 13
  const is32Flow = currentDay <= 4 && currentHour >= 13
  const is33Flow = currentDay == 5 && currentHour >= 13

  let terminationDate

  if (is31Flow) {
    terminationDate = moment().add(terminationPeriod, 'days')
  }
  if (is32Flow) {
    terminationDate = moment().add(terminationPeriod + 1, 'days')
  }
  if (is33Flow) {
    terminationDate = moment().add(terminationPeriod + 2, 'days')
  }

  let formatedTerminationDate
  const terminationDateNumber = terminationDate.date()
  const terminationMonth = terminationDate.month()

  // If termination date is in next month(or on next after next) and date number is below or equal 15
  if (terminationMonth - currentMonth >= 1 && terminationDateNumber <= 15) {
    formatedTerminationDate = terminationDate.date(15)
  }
  // If termination date is in next month and date number is above 15
  if (terminationMonth - currentMonth == 1 && terminationDateNumber > 15) {
    const lastDate = terminationDate.daysInMonth()
    formatedTerminationDate = terminationDate.date(lastDate)
  }
  // If termination date is in current month and date number is above 15
  if (terminationMonth - currentMonth == 0 && terminationDateNumber > 15) {
    const lastDate = terminationDate.daysInMonth()
    formatedTerminationDate = terminationDate.date(lastDate)
  }

  return formatedTerminationDate
}

export const getImmediateTerminationEndDate = () => {
  const terminationPeriod = 2

  const currentMoment = moment()
  const currentHour = currentMoment.hours()
  const currentDay = currentMoment.day()

  const is2DaysFlow = currentDay <= 5 && currentHour < 13
  const is3DaysFlow = currentDay <= 4 && currentHour >= 13
  const is5DaysFlow = currentDay == 5 && currentHour >= 13

  let terminationDate

  if (is2DaysFlow) {
    terminationDate = moment().add(terminationPeriod, 'days')
  }
  if (is3DaysFlow) {
    terminationDate = moment().add(terminationPeriod + 1, 'days')
  }
  if (is5DaysFlow) {
    terminationDate = moment().add(terminationPeriod + 3, 'days')
  }

  return terminationDate
}

export const cutAddsNameToFixedWordsNumber = (
  string,
  number,
  type,
  contract,
  add,
) => {
  if (
    ![
      GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SEND_LETTER,
      GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SHOW_UP,
      GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_LESS_THAN_6_MONTH,
      GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_MORE_THAN_6_MONTH,
    ].includes(type)
  )
    return generateFullAddendumName(add, string, contract)
  let words = string.split(' ')
  if (words.length > number) {
    const array = words.slice(0, number)
    if (array[array.length - 1] == '-') {
      return words.slice(0, number + 1).join(' ') + ' ...'
    } else {
      return words.slice(0, number).join(' ') + ' ...'
    }
  } else {
    return string
  }
}

export const generateFullAddendumName = (add, string, contract) => {
  return (
    string +
    ` ${String(contract.metadata.serialNumber)}.` +
    `${add.metadata.serialNumber}`
  )
}
